<template>
  <v-row class="mx-0 mt-5 mb-4">
    <v-col v-if="loaded">
      <v-row>
        <v-col class="pt-0">
          <v-layout align-center mb-5 class="successTitle">
            <div>
              <v-icon x-large color="error">{{ alertIcon }}</v-icon>
            </div>
            <v-flex mx-2 class="title" mt-1>
              <label v-html="failureMsg"></label>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
      <v-row justify-space-between v-if="isHybridPaymentActive">
        <v-col class="oneBtnCont">
          <v-btn
            elevation="0"
            block
            class="mainOutlinedButton"
            :rounded="templateConfig.isButtonRounded"
            :loading="loading"
            @click="redirectToMerchantPage()"
          >
            <span v-html="hybridFailureBtnText" v-if="!loading"></span>
          </v-btn>
        </v-col>
        <v-col class="oneBtnCont">
          <v-btn
            elevation="0"
            block
            class="mainButton"
            :rounded="templateConfig.isButtonRounded"
            @click="reSetOTPFlow()"
          >
            <span v-html="hybridTryAgainBtnText"></span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-2" v-else>
        <v-col>
          <v-btn
            elevation="0"
            block
            class="mainButton redirectionBtn"
            :class="startLoading"
            :loading="loading"
            :rounded="templateConfig.isButtonRounded"
            @click="redirectToMerchantPage()"
          >
            <span v-html="failureBtnText" v-if="!loading"></span>
          </v-btn>
        </v-col>
      </v-row>
      <SecondaryDisclaimer v-if="failureSecondaryDisclaimerText">
        <div v-html="failureSecondaryDisclaimerText" class="secondryDisc"></div>
      </SecondaryDisclaimer>
    </v-col>
    <v-col v-else>
      <MainLoader />
    </v-col>
  </v-row>
</template>

<script>
import { mdiAlertCircleOutline } from '@mdi/js'; //named import for Alert Icon.
import { mapState, mapMutations } from 'vuex';
import storedData from "constants/storedData";
import MainLoader from '../../Shared/components/MainLoader.vue';
import SecondaryDisclaimer from '../../Shared/components/Disclaimer.vue';

/*
OTP failure mounted only with "operationStatusCode" from the store
*/

export default {
  components: { MainLoader, SecondaryDisclaimer },
  computed: {
    ...mapState(['templateConfig', 'merchantConfig', 'OTPDetails']),
    failureBtnText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.failureBtn;
    },
    hybridFailureBtnText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.hybridFailureBtn;
    },
    hybridTryAgainBtnText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.hybridTryAgainBtn;
    },
    failureSecondaryDisclaimerText() {
      //No need for $replacePlaceholders plugin function.
      return this.merchantConfig.texts.failureSecondaryDisclaimer;
    },
    isHybridPaymentActive() {
      return (
        this.merchantConfig.configs.isHybridPayment &&
        this.failureData.responseCode === 4 //[responseCode = 4] ==> "not enough credit".
      );
    },
  },
  data() {
    return {
      loading: false,
      startLoading: '',
      failureData: {},
      failureMsg: '',
      loaded: false,
      hybridPaymentType: '',
      alertIcon: mdiAlertCircleOutline,
    };
  },
  methods: {
    ...mapMutations(['setOTPDetails']),
    redirectToMerchantPage() {
      this.loading = true;
      if (this.isHybridPaymentActive) {
        sessionStorage.removeItem(storedData.isHybridTrial);
        sessionStorage.removeItem(storedData.hybridPaymentType);
      }

      window.location.replace(this.failureData.redirectUrl);
    },
    reSetOTPFlow() {
      // saved in session storage to keep track these flags in case of operator redirection flow
      !sessionStorage.getItem(storedData.isHybridTrial) &&
        sessionStorage.setItem(storedData.isHybridTrial, 'true');
      !sessionStorage.getItem(storedData.hybridPaymentType) &&
        sessionStorage.setItem(storedData.hybridPaymentType, this.hybridPaymentType);

      this.setOTPDetails({ component: 'OTPInit', step: 1 });
    },
  },

  //activated() instead of created() to update data with keep alive
  async activated() {
    let isHybridPaymentConfig = this.merchantConfig.configs.isHybridPayment;
    let operatorIsEditable = this.merchantConfig.fields[1].isEditable;
    let response = await this.$http.get(
      `/Payment/GetPaymentConfirmationResponse/otp?OperationStatusCode=error&responseCode=${this.OTPDetails.operationStatusCode}&PreserveUser=${isHybridPaymentConfig}`
    );
    // let response = {
    //   data: {
    //     redirectUrl:
    //       'https://vouchers.tpay.me/ar-eg/pubg/ooredoo-oman?operationStatusCode=4&transactionId=18599821098&amountCharged=&operatorCode=42203&msisdn=96896474846&orderInfo=PUBG,False,7192&productCatalogName=tencent&productId=UC60&language=2&errorMessage=&checkoutId=4d11791c60197447823e83fc048b8e1e&signature=8Kr8BejvqMnJLRRvNt1U:cbcdc335265b311c664878725a913ddfd349bd67e7cabec4f0a69dfff0e8ea54',
    //     statusCode: 0,
    //     responseCode: 4,
    //   },
    // };
    this.failureData = response.data;
    this.failureMsg = this.$translate(
      `RESPONSECODE_${this.failureData.responseCode}`
    );

    if (isHybridPaymentConfig && this.failureData.responseCode === 4) {
      if (!this.merchantConfig.configs.SeparateDCBFromWallets) {
        let response = await this.$http.get(
          `/merchant/ProductSupportsHybridSolution?catalogName=${
            this.OTPDetails.productCatalogName
          }${
            this.OTPDetails.productId
              ? `&productSKU=${this.OTPDetails.productId}`
              : ``
          }${
            this.OTPDetails.operatorCode
              ? `&operatorCode=${this.OTPDetails.operatorCode}`
              : ``
          }`
        );
        // let response = {
        //   data: { supportsMobileWallet: true, supportsMultipleOperators: true },
        // };
        if (
          response.data.supportsMobileWallet &&
          response.data.supportsMultipleOperators &&
          operatorIsEditable
        ) {
          // wallet
          this.hybridPaymentType = 'wallet';
          this.failureMsg = this.merchantConfig.texts.hybridWalletMsg;
        } else {
          // DCB
          this.hybridPaymentType = 'DCB';
          this.failureMsg = this.merchantConfig.texts.hybridDCBMsg;
        }
      } else {
        this.hybridPaymentType = this.OTPDetails.paymentProviderType;
        this.failureMsg = this.merchantConfig.texts.hybridDCBMsg;
      }
    }else{
      setTimeout(() => {
      this.startLoading = 'startLoading';
    }, 100);

    setTimeout(() => {
      this.redirectToMerchantPage();
    }, 6000);
    }
    this.loaded = true;
  },
};
</script>
